import { render } from "./IconAscend.vue?vue&type=template&id=6fd8b496"
import script from "./IconAscend.vue?vue&type=script&lang=js"
export * from "./IconAscend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__